import { QueryHookOptions, useQuery } from '@apollo/client';

import query from './userCaseLinks.graphql';

export default function useUserCaseLinksQuery(
  opts?: QueryHookOptions<UserCaseLinksQuery, UserCaseLinksQueryVariables>,
) {
  return useQuery<UserCaseLinksQuery, UserCaseLinksQueryVariables>(query, opts);
}
